import Http from '@/services/http';
import { AppConfiguration } from 'sigma-mappings';
import store from '../store';
import { isConnectionError, trip, reset } from './http/connectivityCircuit';

const configUrl = '/ParametroSistema';

function requestConfiguration() {
  const http = new Http({
    errorHandling: { ignore: error => isConnectionError(error) },
  });
  return http.get(configUrl).then((response) => {
    const config = new AppConfiguration(response.data);
    store.dispatch('setConfiguration', config);
    reset();
  }).catch((error) => {
    if (isConnectionError(error)) {
      trip(requestConfiguration);
      return Promise.resolve();
    }
    store.dispatch('setErrorGettingConfiguration');
    return Promise.reject(error);
  });
}

export default {
  requestConfiguration,
  refreshConfiguration() {
    requestConfiguration();
  },
};
